module.exports = __webpack_public_path__ + "img/story-22.jpg";